export const TRANSIENT_TOKEN = 'transient_token';
